<template>
  <div class="cinza_fundo">
    <div class="row noticiassection align-center">
      <div class="small-10 medium-9 large-9 columns" id="mainrow">
        <div class="noticiasgrid">
          <Noticia :noticia="news" v-for="news in recentNews"/>
        </div>      
        <router-link to="/noticiassas" class="morelinks">
          <i class="fa fa-plus-square-o"></i>
          {{ $t("UMA_LANG_SASUMA_VERMAIS")}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import axios from "@/axios";
import Noticia from "@/components/Noticia.vue";
import { i18n } from '@/main.js';

export default {
  components:{
    Noticia
  },
  setup () {
    const recentNews = ref([]);
    const url = `${import.meta.env.VITE_APP_AXIOS}/noticiassas?limit=3&publicado=1&idioma=${i18n.global.locale}&owner=${import.meta.env.VITE_APP_OWNER}&sort=noticia_data_publicacao`;
    axios.get(url).then(data => {
      recentNews.value = data.data.data.map(el => {
          return {
              ...el,
              imagem: `${import.meta.env.VITE_APP_SITEURL}/wp-content/uploads/${el.noticia_imagem}`
          }
      });
    }).catch(error => {
      console.log(error);
    })

    return {
      recentNews
    }
  }
}
</script>

<style lang="scss" scoped>
.cinza_fundo {
  background-color: #f0f0f3!important;
  position: relative;
}

#mainrow{
  padding-right: 0rem;
  padding-left: 0rem;
}

.noticiassection {
  padding-top: 120px;
  padding-bottom: 120px;
  padding-left: 10px;
  padding-right: 10px;
}

.morelinks,
.morelinks:hover{
  font-family: 'Montserrat Bold';
  color: white;
  text-transform: uppercase;
  color: #6eb7ec;
  left: 0;
  bottom: 0;
  z-index: 50;
  text-transform: uppercase;
  margin-top: 50px;
  display: flex;
  font-size: 15px;
  align-items: center;
}

.morelinks i {
  margin-right: 10px;
  font-size: 24px;
}

.row.noticiassection .row {
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
  padding-bottom: 12px;
}

.newsrow .columns {
  padding-left: 0;
  padding-right: 0;
}

.newsrow .columns {
  padding-left: 0;
  padding-right: 0;
}

.newsrow .newcolumn:nth-of-type(1){
    margin-left: 0;
}

.newsrow .newcolumn{
    position: relative;
}

@media (max-width: 767px) {
  #mainrow {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .noticiassection .morelinks {
    margin-top: 0px;
  }

  .noticiassection {
    padding-top: 60px;
    margin-bottom: 0px;
    padding-bottom: 55px;
  }
}

.noticiasgrid{
  display: grid;
  grid-template-columns: repeat(3,1fr);
  grid-gap: 15px;
}

@media screen and (max-width: 1024px) {
  .noticiasgrid{
    grid-template-columns: repeat(1,1fr);
    grid-gap: 0;
  }
}

</style>